import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
import { BASE_URL } from '../constants/urls';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loadingAuth, setLoadingAuth] = useState(true); 

  const auth = async (incentiveId) => {

    const token = localStorage.getItem("token");

    if (!token) {
      setIsAuthenticated(false);
      setLoadingAuth(false);
      return false;
    }

    try {
      const response = await axios.post(
        `${BASE_URL}/auth/validate-token`,
        { token },
        {
          headers: { Authorization: `Bearer ${process.env.REACT_APP_API_TOKEN}` },
        }
      );

      const valid = incentiveId
        ? incentiveId === response.data.incentiveId
        : response.status === 201;

      setIsAuthenticated(valid);
      return valid;

    } catch (error) {
      setIsAuthenticated(false);
      return false;
    } finally {
      setLoadingAuth(false);
    }
  };

  const logout = () => {
    localStorage.removeItem("token");
    setIsAuthenticated(false);
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, auth, logout, loadingAuth }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};
